import {ConfirmCompanyPresenter} from "@modules/onBoarding/application/port/output/ConfirmCompanyPresenter";
import {ConfirmCompanyViewModel} from "@modules/onBoarding/presentation/viewModel/ConfirmCompanyViewModel";

export class ConfirmCompanyWebPresenter implements ConfirmCompanyPresenter {
    private viewModel: ConfirmCompanyViewModel = {
        isAlreadyRegistered: false,
    };

    notifyCompanyAlreadyRegistered(): void {
        this.viewModel.isAlreadyRegistered = true;
    }

    notifyCompanyNotRegistered(): void {
        this.viewModel.isAlreadyRegistered = false;
    }

    getViewModel(): ConfirmCompanyViewModel {
        return this.viewModel;
    }
}
